export class LoadCapacity {
  constructor(
    public readonly hijslastNaam: string,
    public readonly hijslastEg: string,
    public readonly hijslastContingency: string,
    public readonly hijslastProjectieVlak: string,
  ) {}

  static fromJson(json: any): LoadCapacity {
    return new LoadCapacity(
      json["hijslastNaam"],
      json["hijslastEg"],
      json["hijslastContingency"],
      json["hijslastProjectieVlak"],
    );
  }
}
